module.exports = __webpack_public_path__ + "static/media/galerija_2016 (13).4cc41cf2.jpg";